let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4CfTY")).then(() => parcelRequire('28NpI'));